import { useFormContext } from 'react-hook-form';
import type { z } from 'zod';
import type { ProjectFormSchema } from '../projects/forms/_model/project-form';

type FormValues = z.infer<typeof ProjectFormSchema>;
type InitialFormValues = {
  sheetType: FormValues['sheetType'] | null | undefined;
  data: Partial<FormValues['data']>;
};

export const useProjectFormContext = () =>
  useFormContext<InitialFormValues, unknown, FormValues>();
